import type { ElementType, HTMLAttributes } from 'react';

import { cn } from '../cn';
import { card, type CardVariants } from '../recipes/card';

type CardProps = CardVariants &
  HTMLAttributes<HTMLElement> & {
    /**
     * `figure` is for a card holding a quote and its attribution: a figcaption
     * without a figure is read as loose text.
     */
    as?: Extract<ElementType, 'article' | 'aside' | 'div' | 'figure' | 'li' | 'section'>;
  };

export const Card = ({ as: Tag = 'div', padding, elevation, interactive, className, ...props }: CardProps) => (
  <Tag className={cn(card({ padding, elevation, interactive }), className)} {...props} />
);
